import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
}

export async function contactCategoryDeleteApi(payload: RequestDataShape, token: string) {
	const endpoint = "/contact/category/delete/v1"
	const requester = new ApiRequester<RequestDataShape, void>(endpoint)
	await requester.sendRequest(payload, token)
}
